import { ProspectErrorCodes } from '.';

export const prospectErrorMessage: Partial<Record<ProspectErrorCodes, string>> = {
  INTERNAL_SERVER_ERROR: 'Ocurrió un error en nuestros sistemas. Por favor, intente más tarde.',
  UNKNOWN_ERROR: 'Ocurrió un error inesperado. Nuestro equipo ha sido notificado.',
  RESOURCE_NOT_FOUND: 'El recurso que buscas no se pudo encontrar.',
  PROSPECT_NOT_FOUND: 'El prospecto solicitado no existe.',
  DOCUMENT_NOT_FOUND: 'El documento solicitado no se encontró.',
  INVALID_OTP_CODE: 'El código de verificación es incorrecto, por favor intenta de nuevo.',
  INVALID_TOKEN: 'Tu sesión ha expirado. Por favor, inicia sesión otra vez.',
  VALIDATION_FAILED: 'Por favor, revisa los campos. Hay errores en el formulario.',
  INVALID_ATTRIBUTE: 'Hay un error con el documento seleccionado.',
  DOCUMENT_ALREADY_EXISTS: 'Ya existe un documento con ese nombre o identificador.',
  DOCUMENT_ALREADY_APPROVED: 'Este documento ya ha sido aprobado y no se puede modificar.',
  DOCUMENT_ALREADY_REJECTED: 'Este documento ya ha sido rechazado.',
  INVALID_PROSPECT_STATE: 'El prospecto fue rechazado o no está en un estado válido.',
};

export const PROSPECT_STATES = {
  COMPLETED: 'COMPLETED',
  REJECTED: 'REJECTED',
  IN_REVIEW: 'IN_REVIEW',
};

export const PROSPECT_DOCUMENT_STATES = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
};
